import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ReceptionService } from '@app/service/reception.service';
import { CompanyfacilityService } from '@app/service/companyfacility.service';

import * as $ from 'jquery';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-print-dm',
  templateUrl: './print-dm.component.html',
  styleUrls: ['./print-dm.component.scss']
})
export class PrintDmComponent implements OnInit {

  private params: any;
  private seqArray: any;
  public addressType: any;
  public recipient: any;

  public dmList: any[] = [];

  public year: any = moment().format('YYYY');
  public month: any = moment().format('MM');
  public day: any = moment().format('DD');

  /*******************************************************************************
    설  명 : 생성자
  *******************************************************************************/
  constructor(
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private receptionService: ReceptionService,
    private companyfacilityService: CompanyfacilityService,

  ) { }

  /*******************************************************************************
    설  명 : 생성자
  *******************************************************************************/
  ngOnInit() {
    // 파라미터 가져오기
    this.params = JSON.parse( sessionStorage.getItem( 'inspectHistoryPrintDm' ) );
    sessionStorage.removeItem( 'inspectHistoryPrintDm' );

    this.addressType = this.params.type;
    this.seqArray = JSON.stringify( this.params.seq );
    this.recipient = this.params.recipient;

    if ( this.addressType == 'C' ) {
      this.getCompanyDmList();
    } else {
      this.getReceptionDmList();
    }
  }

  /*******************************************************************************
    설  명 : view 로딩 후 생성자
  *******************************************************************************/
  ngAfterViewInit() {
    var data = $(".table tbody").children();
    setTimeout (() => {
      if( typeof data[0] !== undefined ) {
        window.print();
      }
    }, 500);
  }

  /*******************************************************************************
    설  명 : 검사접수 DM리스트 가져오기
  *******************************************************************************/
  getReceptionDmList() {
    this.receptionService.getReceptionDmList( this.seqArray ).then( response => {
      //console.log(response);
      if( response.ResultCode ) {
        this.dmList = response.data;
        //console.log(this.dmList);
      } else {
        this.toastrService.error( response.ResultMessage, '');
      }
    });
  }

  /*******************************************************************************
    설  명 : 업체 DM리스트 가져오기
  *******************************************************************************/
  getCompanyDmList() {
    this.companyfacilityService.getCompanyDmList( this.seqArray ).then( response => {
      //console.log(response);
      if( response.ResultCode ) {
        this.dmList = response.data;
        //console.log(this.dmList);
      } else {
        this.toastrService.error( response.ResultMessage, '');
      }
    });
  }

}
